const menuItems = [{
  id: 'bids',
  name: 'Bids',
  router_link: [{
    link: 'RfqList',
  }],
  permission: 'view_bids',
  icon: 'bids',
}, {
  id: 'mdm',
  name: 'Data Manager',
  permission: 'view_mdm',
  icon: 'data',
}, {
  id: 'indents',
  name: 'Indents',
  router_link: [{
    link: 'IndentsList',
  }],
  permission: 'view_indents',
  icon: 'orders',
}, {
  id: 'Historic indents',
  name: 'Historic indents',
  router_link: [{
    link: 'HistoricIndentsList',
  }],
  permission: 'view_historic_indents',
  icon: 'orders',
}, {
  id: 'pay_primary', // For marico pay v1 v2 comparison
  name: 'Pay-Primary',
  router_link: [{
    link: 'PaymentList',
  }],
  permission: 'view_pay',
  config: 'pay_v1_v2',
  icon: 'pay',
}, {
  id: 'pay_secondary', // For marico pay v1 v2 comparison
  name: 'Pay-Secondary',
  router_link: [{
    feature: 'payments_v2',
    link: 'payments',
  }],
  permission: 'view_pay',
  config: 'pay_v1_v2',
  icon: 'pay',
}, {
  id: 'pay',
  name: 'Pay',
  router_link: [{
    feature: 'payments_v2', // Gives priority to first link if multiple feature is enabled
    link: 'payments',
  }, {
    link: 'PaymentList',
  }],
  permission: 'view_pay',
  not_config: 'pay_v1_v2',
  icon: 'pay',
}, {
  id: 'pay_v1_deprecate', // For marico pay v1 v2 comparison
  name: 'Pay V1 (Deprecated)',
  router_link: [{
    link: 'PaymentList',
  }],
  permission: 'view_pay',
  config: 'deprecate_pay_v1',
  icon: 'pay',
}, {
  id: 'tracking',
  name: 'Tracking',
  router_link: [{
    link: 'Tracking',
  }],
  permission: 'view_tracking',
  icon: 'setting',
},
{
  id: 'reports',
  name: 'Reports',
  router_link: [{
    link: 'Reports',
    feature: 'transporter_reports',
  }],
  feature: 'transporter_reports',
  permission: 'view_reports',
  icon: 'reports',
},
{
  id: 'reportsv2',
  name: 'Reports',
  router_link: [{
    link: 'ReportsV2',
    feature: 'report_v2',
  }],
  feature: 'report_v2',
  permission: 'view_reports',
  icon: 'reports',
}, {
  id: 'firstInTransporters',
  name: 'First In Allotment',
  router_link: [{
    link: 'FirstInAllotmentList',
  }],
  permission: 'view_first_in_allotment',
  icon: 'first-in-allotment',
}, {
  id: 'indentRepublishRequests',
  name: 'Indent Requests',
  router_link: [{
    link: 'IndentRepublishRequests',
  }],
  permission: 'view_indent_requests',
  icon: 'first-in-allotment',
}];

module.exports = menuItems;

/**
 *
 */
